import { createSlice } from '@reduxjs/toolkit';
import { defaultCatalogSlice } from '@/redux/modules/catalog/catalog.types';
import { fetchCatalogs } from '@/redux/modules/catalog/catalog.actions';
import difference from 'lodash/difference';
import union from 'lodash/union';

const catalogSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchCatalogs.pending, (slice, { meta }) => {
            slice.loading = union(slice.loading, meta.arg.catalogIds);
        });
        builder.addCase(fetchCatalogs.fulfilled, (slice, { meta, payload }) => {
            payload.forEach((catalog) => {
                slice.byId[catalog.catalogId] = catalog;
                slice.loaded[catalog.catalogId] = Date.now();
            });
            slice.loading = difference(slice.loading, meta.arg.catalogIds);
        });
        builder.addCase(fetchCatalogs.rejected, (slice, { meta }) => {
            slice.loading = difference(slice.loading, meta.arg.catalogIds);
        });
    },
    initialState: defaultCatalogSlice,
    name: 'catalog',
    reducers: {},
});

export const { reducer: catalogReducer } = catalogSlice;
